/* eslint-disable */

import React from 'react';
import './InfoCard.css';

/**
 * Custom InfoCard component ที่ปรับแต่งง่ายกว่า Antd Card
 * @param {string} title - หัวข้อของ card
 * @param {React.ReactNode} icon - icon component (optional)
 * @param {string} variant - 'default' | 'primary' | 'success' | 'warning' | 'danger'
 * @param {boolean} bordered - แสดง border หรือไม่
 * @param {boolean} compact - ลดขนาด padding
 * @param {boolean} matchHeight - ให้ card สูงเต็ม container (ใช้กับ InfoGrid)
 * @param {boolean} centered - จัด content ให้อยู่กลาง card (ใช้เมื่อมี content น้อย)
 * @param {React.ReactNode} extra - element เพิ่มเติมด้านขวาของ header
 * @param {React.ReactNode} children - เนื้อหาภายใน card
 */
const InfoCard = ({
  title,
  icon,
  variant = 'default',
  bordered = true,
  compact = false,
  matchHeight = false,
  centered = false,
  extra,
  children,
  className = '',
  style = {},
}) => {
  const cardClasses = [
    'info-card',
    `info-card--${variant}`,
    bordered ? 'info-card--bordered' : '',
    compact ? 'info-card--compact' : '',
    matchHeight ? 'info-card--match-height' : '',
    centered ? 'info-card--centered' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClasses} style={style}>
      {(title || extra) && (
        <div className='info-card__header'>
          <div className='info-card__title'>
            {icon && <span className='info-card__icon'>{icon}</span>}
            <span>{title}</span>
          </div>
          {extra && <div className='info-card__extra'>{extra}</div>}
        </div>
      )}
      <div className='info-card__body'>{children}</div>
    </div>
  );
};

/**
 * InfoRow - แถวแสดงข้อมูลแบบ label-value
 * @param {string} label - ชื่อ field
 * @param {React.ReactNode} value - ค่าของ field
 * @param {string} valueColor - สีของค่า (optional)
 * @param {boolean} bold - ทำให้ค่าเป็นตัวหนา
 */
export const InfoRow = ({ label, value, valueColor, bold = false, className = '' }) => {
  const valueStyles = {
    ...(valueColor && { color: valueColor }),
    ...(bold && { fontWeight: 600 }),
  };

  return (
    <div className={`info-row ${className}`}>
      <span className='info-row__label'>{label}</span>
      <span className='info-row__value' style={valueStyles}>
        {value ?? '-'}
      </span>
    </div>
  );
};

/**
 * InfoGrid - จัดข้อมูลแบบ grid
 * @param {number} columns - จำนวน columns (default: 2)
 */
export const InfoGrid = ({ columns = 2, children, className = '' }) => {
  return (
    <div className={`info-grid ${className}`} style={{ '--info-grid-columns': columns }}>
      {children}
    </div>
  );
};

/**
 * InfoDivider - เส้นแบ่ง section
 */
export const InfoDivider = ({ label }) => {
  return (
    <div className='info-divider'>
      {label && <span className='info-divider__label'>{label}</span>}
    </div>
  );
};

export default InfoCard;
